export const DeleteCountry = (Datas, capital) => {
  return Datas.filter((country) => country.capital !== capital)
}

